/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/237-cool2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 0a8 8 0 100 16A8 8 0 008 0zm0 13a4.984 4.984 0 01-2.118-.47l.518-.864a3.996 3.996 0 005.03-1.608l.858.515A4.996 4.996 0 018 13zm5-7c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1H7c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V4.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5V5h2v-.5c0-.275.225-.5.5-.5h3c.275 0 .5.225.5.5V6z"/>'
  }
})
